import React, { useState, useEffect, useCallback,useMemo } from 'react';
import { getData,addData, updateData ,deleteData} from '../../services/seoTwitterCardServices';
import { Button, Modal,Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { admin_base_url } from '../../config';
import axios from 'axios';

const Seotwittercard = () => {
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null,
    page_name:'',
    // context_page:'',
    twitter_card: 'summary',
    twitter_site: '',
    twitter_title: '',
    twitter_description: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [dataList, setDataList] = useState([]);
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [pageNameOptions, setPageNameOptions] = useState([
  //   { value: "", label: "Select Page" }
  // ]);

  // Fetch data from API
  const fetchData = useCallback(async () => {
    setLoading(true);
    try{
    const response = await getData();
    if (response.data.length > 0) {
      setDataList(response.data); // Load first record into the form
    }
  }
  catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Validate form data
  const validateForm = () => {
  const newErrors = {};
  const urlPattern = new RegExp(
  "^(https?:\\/\\/)" + // protocol required
  "((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|" + // domain...
  "localhost|" + // or localhost
  "\\d{1,3}(\\.\\d{1,3}){3})" + // ...or IPv4
  "(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$"
  );
  if (!formData.twitter_card) newErrors.twitter_card = "twitter_card  is required";
  if (!formData.page_name) newErrors.page_name = "Page name is required";
  // if (!formData.context_page) newErrors.context_page = "Context Page is required";
  if (!formData.twitter_site){
    newErrors.twitter_site = "twitter_site is required";
  }
  else if (!urlPattern.test(formData.twitter_site.trim())) {
    newErrors.twitter_site = "Invalid URL format";
  }
  if (!formData.twitter_title) newErrors.twitter_title = "twitter_title is required";
  if (!formData.twitter_description) newErrors.twitter_description = "twitter_description is required";
  if (formData.twitter_description.length < 70 || formData.twitter_description.length > 200) newErrors.twitter_description = " twitter_description should be between 70 and 260 characters";

  if (!formData.uploadedfile && formData.uploadedfile === null) {
      if (!errors.uploadedfile) newErrors.uploadedfile = " Twitter Image is required";
  }
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
}

  // Handle input changes
  const handleChange = async(e) => {
    try{
        const { name, value, files } = e.target;
        const file = files?.[0]
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
              const fileType = file.type.includes("image") ? "img" : "pdf";
              const isValid = await validateFile(file, setErrors,name,fileType);
              if (isValid) {
                updatedData[name] = file;
                updatedErrors[name] = '';
              }
              else{
                return ; // Don't update if invalid
              }
        } 
          else{
          updatedData[name] = value;
          if (name === "page_name") {
            const isDuplicate = dataList.some(
              (item) => item.page_name?.toLowerCase() === value.toLowerCase()
            );

            if (isDuplicate) {
              updatedErrors[name] = "Page name already exists";
            } else {
              updatedErrors[name] = ''; // Clear error if unique
            }
          }
          else if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }}
        setFormData(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
     if (!validateForm()) {
        return
      }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('twitter_card', formData.twitter_card);
    form.append('page_name', formData.page_name);
    // form.append('context_page', formData.context_page);
    form.append('twitter_site', formData.twitter_site.trim());
    form.append('twitter_title', formData.twitter_title);
    form.append('twitter_description', formData.twitter_description);
    form.append('uploadedfile', formData.uploadedfile);
    if (modalType === 'add') {
      let response = await addData(form);
            if (response.status === 200||201) {
            fetchData();
            setShowModal(false);
              toast.success("Added Successfully!", {
                position: 'top-right',
                autoClose: 3000,
              });
            } 
            else{
                toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
            console.log((response?.message || "Failed to process request."));
            }
          }
    else if (modalType === 'edit') {
        let  response = await updateData(form);
        if (response && response.status === 200) {
          fetchData();  // Re-fetch data after adding/editing
          setShowModal(false);
          toast.success("Updated Successfully!", {position: 'top-right',autoClose: 3000,});
                }
        else{
        toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        console.log((response?.message || "Failed to process request."));
          }
      }
  }
  catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };


  const handleDelete = async () => {
        try{
        if (selectedData) {
          // Optimistically remove the data from the list
          setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
          // Proceed with the actual delete request
          await deleteData(selectedData.id);
          setShowDeleteConfirmModal(false);
          toast.success("Deleted Successfully!", {position: 'top-right',autoClose: 3000});
        }
      }
      catch (error) {
            console.error('Error deleting data:', error);
          }
      };
  
   const openModal = (type, data = { id: '', page_name: '',
    // context_page: '',
    uploadedfile: null,
    twitter_card: 'summary',
    twitter_site: '',
    twitter_title: '',
    twitter_description: '',
    }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };


  const openDeleteConfirmModal = (data) => {
        setSelectedData(data);
        setShowDeleteConfirmModal(true);
      };
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
    
// Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered =  dataList.filter(
      (data) =>
        data?.page_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
        data?.twitter_card?.toLowerCase().includes(searchText?.toLowerCase()) 
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData;
  }, [dataList, searchText]);

  const columns = [
        {
          name: '#',
          selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
          sortable: false,
          width: '10%',
        },
        {
          name: 'Page name',
          selector: (row) => (<span title={row.page_name}>{row.page_name}</span>),
          sortable: true,
          width: '20%',
        },
        {
          name: 'Twitter Card',
          selector: (row) => row.twitter_card,
          sortable: true,
          width: '20%',
        },
        {
          name: 'Title',
          selector: (row) => (<span title={row.twitter_title}>{row.twitter_title}</span>),
          sortable: true,
          width: '20%',
        },
  
        {
          name: 'Actions',
          cell: (row) => (
            <div>
              <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
              <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
            </div>
          ),
          width: '25%',
        },
      ];

  const cms_private_key = localStorage.getItem('cms_private_key');
  const cms_sub_domain = localStorage.getItem('cms_sub_domain');
  const admin_api_url = `${admin_base_url}api/admin/metaTags`;

  // const getPagenames = async () => {
  //   try {
  //     const res = await axios.get(admin_api_url, {
  //       headers: {
  //         cms_private_key: cms_private_key, 
  //         cms_sub_domain:cms_sub_domain 
  //       }
  //     });

  //     const options = res.data.data.map((item) => ({
  //       value: item.page_value,
  //       label: item.page_title
  //     }));

  //     // Add default option on top
  //     setPageNameOptions([
  //       { value: "", label: "Select Page" },
  //       ...options
  //     ]);
  //   } catch (error) {
  //     console.error("Error fetching meta tags:", error);
  //   }
  // };

  // useEffect(() => {
  //     getPagenames();
  //   }, []);

  const pageNameOptions = [
      { value: "", label: "Select Page" },
      { value: "default", label: "Default" },
      // { value: "about-us", label: "About us" },
      // { value: "brochure", label: "Brochure" },
      // { value: "venue", label: "Venue" },
      // { value: "ocm", label: "OCM" },
      // { value: "program-speakers", label: "Program Speakers" },
      // { value: "registration", label: "Registration" },
      // { value: "submit-abstract", label: "Submit Abstract" },
      // { value: "sessions", label: "Sessions" },
      // { value: "home", label: "Home" },
      // { value: "terms-and-conditions", label: "Terms and Conditions" },
      // { value: "contact-us", label: "Contact us" },
      // { value: "webinar-program", label: "Webinar Program" },
      // { value: "scientific-program", label: "Scientific Program" },
      // { value: "about-webinar", label: "About Webinar" },
      // { value: "past-conference", label: "Past Conference" },
      // { value: "pc-report", label: "PC Report" },
      // { value: "pc-proceedings", label: "PC Proceedings" },
      // { value: "pc-attendees", label: "PC Attendees" },
      // { value: "pc-testimonials", label: "PC Testimonials" },
      // { value: "pc-gallery", label: "PC Gallery" },
      // { value: "testimonials", label: "Testimonials" },
      // { value: "supporting-journals", label: "Supporting Journals" },
      // { value: "media-partners", label: "Media Partners" }
    ];

const pageContextOptions = [
      { value: "", label: "Select Context Page" },
      { value: "default", label: "Default" },
      { value: "about-us", label: "About us" },
      { value: "brochure", label: "Brochure" },
      { value: "venue", label: "Venue" },
      { value: "ocm", label: "OCM" },
      { value: "program-speakers", label: "Program Speakers" },
      { value: "registration", label: "Registration" },
      { value: "submit-abstract", label: "Submit Abstract" },
      { value: "sessions", label: "Sessions" },
      { value: "home", label: "Home" },
      { value: "terms-and-conditions", label: "Terms and Conditions" },
      { value: "contact-us", label: "Contact us" },
      { value: "webinar-program", label: "Webinar Program" },
      { value: "scientific-program", label: "Scientific Program" },
      { value: "about-webinar", label: "About Webinar" },
      { value: "past-conference", label: "Past Conference" },
      { value: "pc-report", label: "PC Report" },
      { value: "pc-proceedings", label: "PC Proceedings" },
      { value: "pc-attendees", label: "PC Attendees" },
      { value: "pc-testimonials", label: "PC Testimonials" },
      { value: "pc-gallery", label: "PC Gallery" },
      { value: "testimonials", label: "Testimonials" },
      { value: "supporting-journals", label: "Supporting Journals" },
      { value: "media-partners", label: "Media Partners" }
    ];

  const customStyles = (hasError) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: hasError ? '#f5c2c7' : provided.borderColor, // Light red border
    boxShadow: hasError
      ? '0 0 0 1px rgba(167, 16, 31, 0.91)' // Light red outline glow
      : state.isFocused
        ? '0 0 0 1px #2684FF'
        : provided.boxShadow,
    '&:hover': {
      borderColor: hasError ? '#f5c2c7' : provided.borderColor,
    },
  }),
});

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
         {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>SEO Config <b>/ Twitter Card</b></p>
              {/* <h2 className='mb-3'>Schema Markup</h2> */}
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
          {/* <h1 className="mb-4">Twitter Card</h1> */}

          {/* Editable Form (Always Visible) */}
          {/* <div className="card p-3 mb-4"> */}
            {/* <h4 className='mb-3'>Edit Twitter Card</h4> */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="mb-3">
                  <label htmlFor="page_name" className="form-label">Page Name <small className='text-danger'> * </small></label>
                  <Select
                    id="page_name"
                    name="page_name"
                    value={pageNameOptions.find(opt => opt.value === formData.page_name)}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: 'page_name',
                          value: selectedOption?.value || ''
                        }
                      })
                    }
                    options={pageNameOptions}
                    styles={customStyles(!!errors.page_name)}
                    placeholder="Select Page"
                  />
                  {errors.page_name && (
                    <div className="invalid-feedback d-block">
                      {errors.page_name}
                    </div>
                  )}
                </div>

                {/* <div className="mb-3">
                  <label htmlFor="context_page" className="form-label">Context Page<small className='text-danger'> * </small></label>
                  <Select
                    id="context_page"
                    name="context_page"
                    value={pageContextOptions.find(opt => opt.value === formData.context_page)}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: 'context_page',
                          value: selectedOption?.value || ''
                        }
                      })
                    }
                    options={pageNameOptions}
                    styles={customStyles(!!errors.context_page)}
                    placeholder="Select Context Page"
                  />
                  {errors.context_page && (
                    <div className="invalid-feedback d-block">
                      {errors.context_page}
                    </div>
                  )}
                </div> */}
              <Form.Group className="col-md-8 mb-3">
              <Form.Label className='form-label-custom'>Twitter Title<small className='text-danger'> * </small>Note:<small className='text-primary'> Emptying the Twitter title will disable Twitter tags on the website</small></Form.Label>
              <Form.Control
                  type="text"
                  name="twitter_title"
                  value={formData.twitter_title}
                  onChange={handleChange}
                  isInvalid ={!!errors.twitter_title}
                />
              <Form.Control.Feedback type="invalid">{errors.twitter_title}</Form.Control.Feedback>               
                
              </Form.Group>

              <Form.Group className="col-md-4 mb-3">
                <Form.Label className='form-label-custom'>Twitter Card <small className='text-danger'> * </small></Form.Label>
                <Form.Control
                  type="text"
                  name="twitter_card"
                  value={formData.twitter_card}
                  onChange={handleChange}
                  isInvalid = {!!errors.twitter_card}
                  disabled
                />
              <Form.Control.Feedback type="invalid">{errors.twitter_card}</Form.Control.Feedback>               
              </Form.Group>

              <Form.Group className="col-md-12 mb-3">
                <Form.Label className='form-label-custom'>Twitter Description<small className='text-danger'> * </small> <small className='text-primary'>Char limit: 70-200 | Current char count: {formData.twitter_description.length}</small></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8} 
                  name="twitter_description"
                  value={formData.twitter_description}
                  onChange={handleChange}
                  isInvalid ={!!errors.twitter_description}
                />
              <Form.Control.Feedback type="invalid">{errors.twitter_description}</Form.Control.Feedback>               
              </Form.Group>
              
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Twitter Site <small className='text-danger'> * </small> <small className='text-primary'>https://twitter.com/scientexevents</small></Form.Label>
                <Form.Control
                  type="text"
                  name="twitter_site"
                  value={formData.twitter_site}
                  onChange={handleChange}
                  isInvalid ={!!errors.twitter_site}
                />
              <Form.Control.Feedback type="invalid">{errors.twitter_site}</Form.Control.Feedback>               
              </Form.Group>
              
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Twitter Image <small className='text-danger'> * </small> <small className='text-primary'> (Dim: 1080x1080px | Max-Size: 1MB)</small></Form.Label>
                <Form.Control type="file" name="uploadedfile" onChange={handleChange} isInvalid = {!!errors.uploadedfile}  accept='image/*'/>
              <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>               
                {formData.uploadedfile && typeof formData.uploadedfile === 'string' && (
                  <p>
                    <a href={formData.uploadedfile} target="_blank" rel="noopener noreferrer">
                      View Current File
                    </a>
                  </p>
                )}
              </Form.Group>
             
               
              <Form.Group className="col-md-3 mb-2">
              {formData.twitter_img &&<Form.Label className='form-label-custom'>Twitter Image Preview &nbsp;</Form.Label>}
                {formData.twitter_img && (
                  <div style={{height:'200px',width: '200px', margin:'5px'}}>
                    <img  className='rounded' src={formData.twitter_img} alt="og preview" 
                      width='100%' height='100%'  
                      style={{ objectFit: 'cover' }}
                      crossOrigin="anonymous"
                    />
                  </div>
                )}
                </Form.Group> 
                <Form.Group className="col-md-9 mb-2">
                <Form.Label className='form-label-custom'>&nbsp;</Form.Label>
                {formData.twitter_img ? (
                  <div>
                  <a
                    className="btn btn-warning text-dark"
                    href={formData.twitter_img}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="mdi mdi-open-in-new"></i> Open in new tab
                  </a>
                  </div>
                ) : (
                  <p></p>
                )}
              </Form.Group>                    
              </div>
              {/* <Button variant="success" type="submit">Save</Button> */}
            </Form>
            </Modal.Body>
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>
        <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this row?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
          {/* </div> */}
        </div>
        <Footer />
         </div>
      )}
      </div>
    </div>
  );
};

export default Seotwittercard;
